import React, { createContext, useContext, useState } from "react";
import type { AdminContextType, AdminStateProps } from "./types";
import { defaultValues } from "./defaultValues";

const initialConfig = { ...defaultValues };

const AdminContext = createContext<AdminContextType>(initialConfig);

export const AdminProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [adminState, setAdminState] = useState<AdminStateProps>(
    initialConfig.adminState
  );

  const updateState = (newState: Partial<AdminStateProps>) => {
    setAdminState((prevState: AdminStateProps) => ({
      ...prevState,
      ...newState,
    }));
  };

  const value = {
    adminState,
    updateState,
  };

  return (
    <AdminContext.Provider value={value}>{children}</AdminContext.Provider>
  );
};

const useAdmin = () => useContext(AdminContext);

export default useAdmin;
